<template>
  <NewsListPageContent :sort-type="NavigationSortType.All" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { NavigationSortType } from '~/models/navigation'

const { t } = useI18n()

useHeadMeta({
  title: `${t('head_meta.default_title')}. ${t('menu.feed')} - hot`,
})
</script>
